import en from './en'
import es from './es'
import ru from './ru'

export default {
  ru,
  en,
  es
}
